export default defineNuxtPlugin(() => {
  const { $router } = useNuxtApp();
  window.addEventListener(
    'click',
    (event) => {
      if (!(event.target instanceof Element)) return;

      const path = event.target?.closest('a[data-nuxt-link]')?.getAttribute('href');
      if (!path) return;

      // Don't follow the link & push link destination to router
      event.preventDefault();
      $router.push(path);
    },
    false,
  );
});
